/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Dialog_LevelInputs */



/**
* | output |
* | --- |
* | "Say something — the bar should move" |
*
* @param {Meeting_Offline_Dialog_LevelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_dialog_level = /** @type {((inputs?: Meeting_Offline_Dialog_LevelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Dialog_LevelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zeg iets — het balkje moet bewegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dites quelque chose — la barre doit bouger")
	return /** @type {LocalizedString} */ ("Say something — the bar should move")
});